import React from 'react';
import { AdvancedImage, responsive } from '@cloudinary/react';
import { RichLink } from '@naf-simba/sections-rich-link';
import { useDispatch } from 'react-redux';
import { DEFAULT_IMG_PUBLIC_ID } from '@lib/constants';
import { getMediaProps } from './utils/getMediaProps';
import { LocalArticleSearchResultType } from '../../hooks/GlobalSearchTypes';
import { useCloudinary } from '../../hooks/Cloudinary/useCloudinary';
import { useResolveLink } from '../../hooks/useResolveLink';
import { actions } from '../../redux/modules/user';
import { enableScroll } from '../../hooks/useScrollBlock';
import { useTrackSearchResultClick } from '../../hooks/useTrackSearchResultClick';

interface Props {
  item: LocalArticleSearchResultType;
}

export const LocalArticleResultCard = ({ item }: Props) => {
  const dispatch = useDispatch();
  const { getResponsiveImage } = useCloudinary();
  const { trackClickSearchResult } = useTrackSearchResultClick();
  const href = item.url?.raw;
  const title = item.naf_page_title?.raw || '';
  const text = item.naf_page_description?.raw || item.body_content?.raw;
  const { isInternal, linkProps } = useResolveLink(href);

  const publicId = item.naf_image_publicid?.raw
    ? String(item.naf_image_publicid.raw).split(',')[0]
    : DEFAULT_IMG_PUBLIC_ID;
  const cldImage = getResponsiveImage(publicId);
  const advancedImage = cldImage ? (
    <AdvancedImage cldImg={cldImage} plugins={[responsive({ steps: 200 })]} />
  ) : undefined;
  const imgProp = {
    src: cldImage?.toURL() || '',
    alt: title,
  };

  const media = getMediaProps(advancedImage, imgProp.src ? imgProp : undefined);

  const handleOnClick = () => {
    trackClickSearchResult();
    dispatch(actions.closeMenu());
    enableScroll();
  };

  const description = text || undefined;

  if (isInternal && linkProps.to) {
    return (
      <li key={item.id.raw}>
        <RichLink
          to={linkProps.to}
          title={title}
          description={description}
          media={media}
          variant="standard"
          onClick={handleOnClick}
        />
      </li>
    );
  }

  if (href) {
    return (
      <li key={item.id.raw}>
        <RichLink href={href} title={title} description={description} media={media} variant="standard" />
      </li>
    );
  }

  return null;
};
